var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_24797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 5.55078L43.1595 35.2508L39.9834 39.0617C39.2235 39.9736 38.0977 40.5008 36.9107 40.5008H7.14305C4.06385 40.5008 2.13934 37.1674 3.67895 34.5008L17.8961 9.8759C18.2278 9.30151 18.697 8.8186 19.2616 8.47062L23.9995 5.55078Z",
    fill: "#111B48",
    stroke: "#111B48",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5359 7C24.0755 4.33333 27.9245 4.33333 29.4641 7L43.3205 31C44.8601 33.6667 42.9356 37 39.8564 37H12.1436C9.06439 37 7.13989 33.6667 8.67949 31L22.5359 7Z",
    fill: "white",
    stroke: "#111B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15.5C27.5 16.3284 27.5 25 26 25C24.5 25 24.5 16.3284 24.5 15.5C24.5 14.6716 25.1716 14 26 14C26.8284 14 27.5 14.6716 27.5 15.5Z",
    fill: "#111B48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 28.5,
    r: 1.5,
    fill: "#111B48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_24797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedComments);
export default __webpack_public_path__ + "static/media/FailedComments.73b7994688ec118b8fde6d7604ba0cd3.svg";
export { ForwardRef as ReactComponent };